import React from "react";
import { Button, Container } from "@mui/material";
import "./css/Order.css";
import SendIcon from "@mui/icons-material/Send";
import FinalReview from "./FinalReview";
import { useNavigate } from "react-router-dom";
export const Order = (props) => {
  const [open, setOpen] = React.useState(false);
  const [val, setVal] = React.useState();
  const navigate = useNavigate();
  const [str, setStr] = React.useState("Free");
  const [name, setName] = React.useState([]);
  const [last, setLast] = React.useState([]);
  const [email, setEmail] = React.useState([]);

  const handleChange = (e) => {
    setVal(e.target.value);
    // localStorage.setItem('name', e.target.value)
  };

  const pricingChange = (e) => {
    setStr(e.target.value);
    props.setPayment(e.target.value);
    // localStorage.setItem('str', e.target.value)
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setOpen(true);
  };

  return (
    <div className="main-order">
      <center>
        <h3
          style={{
            color: "#0C2943",
            fontWeight: 700,
            textAlign: "center",
            width: "100%",
            padding: "2%",
            fontFamily: "Alegreya Sans",
            fontStyle: "normal",
            fontSize: "40px",
            lineHeight: "48px",
            opacity: 1,
            zIndex: 2,
          }}
          data-aos="zoom-out-up"
        >
          Review your Order
        </h3>
      </center>
      <div className="order">
        <div className="order-div1">
          <span>
            <h2 style={{ color: "#000", opacity: "1" }} data-aos="zoom-out">
              Your Order
            </h2>
          </span>

          <Container>
            <div className="form-div">
              <div class="form">
                <form
                  onSubmit={(e) => {
                    handleSubmit(e);
                  }}
                  id="form"
                  data-aos="flip-left"
                  data-aos-easing="ease-out-cubic"
                  data-aos-duration="2000"
                >
                  <div class="input-container ic1">
                    <input
                      id="firstname"
                      class="input"
                      type="text"
                      placeholder=" "
                      value={name}
                      onChange={(e) => {
                        setName(e.target.value);
                      }}
                      required
                    />
                    <div class="cut"></div>
                    <label for="firstname" class="placeholder">
                      First name
                    </label>
                  </div>
                  <div class="input-container ic2">
                    <input
                      id="lastname"
                      class="input"
                      type="text"
                      placeholder=" "
                      value={last}
                      onChange={(e) => {
                        setLast(e.target.value);
                      }}
                      required
                    />

                    <label for="lastname" class="placeholder">
                      Last name
                    </label>
                  </div>
                  <div class="input-container ic2">
                    <input
                      id="email"
                      class="input"
                      type="text"
                      placeholder=" "
                      value={email}
                      onChange={(e) => {
                        setEmail(e.target.value);
                        props.setToMail(e.target.value);
                      }}
                      required
                    />
                    <div class="cut cut-short"></div>
                    <label for="email" class="placeholder">
                      Email
                    </label>
                  </div>
                  {/* <div class='input-container ic3'>
                  <label
                    for='language'
                    style={{
                      color: 'white',
                      marginTop: '10px',
                      marginBottom: '10px'
                    }}
                  >
                    Services
                  </label>
                  <select
                    name='language'
                    id='language'
                    onChange={handleChange}
                    required
                  >
                    <option value='Image'>Image</option>
                    <option value='Document'>Document</option>
                    <option value='Api'>Api</option>
                    <option value='Cache' selected>
                      Cache
                    </option>
                  </select>
                </div> */}
                  <div class="input-container ic3">
                    <label
                      for="language"
                      style={{
                        color: "white",
                        marginTop: "10px",
                        marginBottom: "10px",
                      }}
                    >
                      Pricing
                    </label>
                    <select
                      name="language"
                      id="language"
                      onChange={pricingChange}
                      required
                    >
                      <option value="899/month">899/month</option>
                      <option value="Free" selected>
                        Free
                      </option>
                      <option value="399/month">399/month</option>
                    </select>
                  </div>{" "}
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      padding: "20px",
                    }}
                  >
                    <Button
                      variant="contained"
                      color="success"
                      endIcon={<SendIcon />}
                      type="submit"
                    >
                      Proceed To pay
                    </Button>
                  </div>
                </form>
              </div>
            </div>
          </Container>
        </div>

        <div
          className="order-div2"
          data-aos="flip-right"
          data-aos-easing="ease-out-cubic"
          data-aos-duration="2000"
        >
          <Container>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "space-evenly",
                height: "50vh",
              }}
            >
              <>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    background:
                      "linear-gradient(180deg, rgba(7, 92, 169, 0.65) 0%, rgba(94, 243, 216, 0.598) 100%)",
                    boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.25)",
                    borderRadius: "5px",
                  }}
                  class="first-div"
                >
                  <span className="my-auto">{str}</span>
                </div>

                <div
                  style={{ display: "flex", justifyContent: "center" }}
                  id="form-button"
                >
                  <Button
                    variant="contained"
                    onClick={() => {
                      navigate("/service");
                    }}
                  >
                    Continue to Shopping
                  </Button>
                </div>
              </>
            </div>
          </Container>
        </div>
      </div>
      <FinalReview
        open={open}
        setOpen={setOpen}
        name={name}
        last={last}
        email={email}
        str={str}
        val={val}
      />
    </div>
  );
};
